import { render, staticRenderFns } from "./PaiUserAuthorizationAgreement.vue?vue&type=template&id=2b07f0a3&scoped=true"
import script from "./PaiUserAuthorizationAgreement.vue?vue&type=script&lang=js"
export * from "./PaiUserAuthorizationAgreement.vue?vue&type=script&lang=js"
import style0 from "./PaiUserAuthorizationAgreement.vue?vue&type=style&index=0&id=2b07f0a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b07f0a3",
  null
  
)

export default component.exports